class ItemSearch {
  search(param) {
    if (param && param.length) {
      this.render(param);
    } else {
      this.resetState();
    }

    return this.checkView();
  }

  resetState() {
    $('.search-scope .search-item').removeClass('d-none');
  }

  render(param) {
    $('.search-scope .search-item').each(function() {
      if (ItemSearch.seoString($(this).find('.search-param').first().html()).indexOf(ItemSearch.seoString(param)) > -1) {
        $(this).removeClass('d-none');
      } else {
        $(this).addClass('d-none');
      }
    });
  }

  checkView() {
    if (!$('.search-scope .search-item').length || $('.search-scope .search-item:visible').length) {
      $('#no-results').addClass('d-none');
    } else {
      $('#no-results').removeClass('d-none');
    }
  }

  static seoString(string) {
    return string.replace(/[âáàã]/g,'a')
    .replace(/[éèê]/g,'e')
    .replace(/[íìî]/g,'i')
    .replace(/[ôõóò]/g,'o')
    .replace(/[úùû]/g,'u')
    .replace(/[ç]/g,'c')
    .replace(/[ ]/g,'')
    .toLowerCase();
  }
}

const itemSearch = new ItemSearch();